<ng-template #pageActionBarRight>
  <loan-summary-bar
    [options]="loanSummaryOptions"
    [mobileLoanSummaryRenderMode]="'trigger'"
    [isMobileLoanSummaryPanelOpen]="isMobileLoanSummaryPanelVisible"
    (mobileLoanSummaryPanelToggleRequested)="onMobileLoanSummaryPanelToggleRequested()">
  </loan-summary-bar>
</ng-template>

<ng-template #pageActionBarLeft>
  <bread-crum class="tpo-bread-crumb"></bread-crum>
</ng-template>

<ng-template #mainContent>
  @if (isMobileLoanSummaryPanelVisible) {
    <mobile-loan-summary-panel
      (closeRequested)="onMobileLoanSummaryPanelClosed()">
    </mobile-loan-summary-panel>
  }
  <div class="row px-0">
    <div class="col-lg-2">
      <div style="position: sticky; top: -223px;">
        <loan-summary-card
          [loanSummary]="loanSummary"
          [showExplanationSectionForMenuStatusIcons]="showExplanationSectionForMenuStatusIcons">
        </loan-summary-card>

        @if (loanSummary && !useV2Menu) {
          <tpo-menu
            [loanId]="loanId"
            [featurePermissions]="permissions"
            [disclosuresEnabled]="disclosuresEnabled">
          </tpo-menu>
        }
        @if (loanSummary && useV2Menu) {
          <tpo-menu-v2
            [featurePermissions]="permissions"
            [stepStatuses]="stepStatuses"
            [showStepLabels]="!loanSubmissionCompleted"
            [disclosuresEnabled]="disclosuresEnabled">
          </tpo-menu-v2>
        }
      </div>
    </div>
    @if (!isLoadingApplicationDetails) {
      <div class="col-lg-10 g-0">
        @if (application && application.hasException) {
          <div class="col-xs-12">
            <div class="card text-center bg-danger">
              <h4 style="color:white">This loan has an exception</h4>
              <span class="mb-1" style="color:white; word-wrap: break-word; overflow-wrap: break-word; white-space: pre-wrap;">
                <em>{{application.exceptionDescription}}</em>
              </span>
            </div>
          </div>
        }
        @if (isPizzaTrackerEnabled && trackerSteps.length) {
          <pizza-tracker
            [steps]="trackerSteps"
            [activeStepOrder]="activeTrackerStepOrder">
          </pizza-tracker>
        }
        <router-outlet></router-outlet>
      </div>
    } @else {
      <div class="col-lg-10 col-xxl-10 col-xxxl-10">
        <loading-indicator id="tpo-app-detail-loader" [loadingMessage]="'Loading application details...'" [customHeight]="'70vh'" [useTransparentBg]="false"></loading-indicator>
      </div>
    }

    @if (!isPRMG && !isGenway && !isCompanyRoundHouse) {
      <div class="escalationButton">
        <button class="btn btn-primary"
          (click)="createEscalationDialogModal()">E<br>s<br>c<br>a<br>l<br>a<br>t<br>i<br>o<br>n<br></button>
        </div>
      }
    </div>

  </ng-template>

  <tpo-page-template
    [pageMainContentTemplate]="mainContent"
    [pageActionBarLeftContentTemplate]="pageActionBarLeft"
    [pageActionBarRightContentTemplate]="pageActionBarRight">
  </tpo-page-template>
